import { MAX_PHOTOS } from '../../shared/validation';

/**
 * How many more photos a plumber may add to a referral that already has
 * `existingCount` intake photos on it, given the shared per-referral cap
 * (`MAX_PHOTOS`, enforced server-side per referral per kind in
 * functions/api/referrals/[id]/photos.ts).
 *
 * The result is the `max` a caller should hand to `PhotoPicker`: that
 * component only knows about the files freshly picked in this session, not
 * photos already saved on the referral, so without this the plumber could
 * pick up to MAX_PHOTOS more on top of what is already there and get a 409
 * back from the server on the last one.
 *
 * Never negative, and never inflated by a bad `existingCount`: a count at or
 * above the cap leaves zero room, and a negative count (which should not
 * happen, but a photo list length is data from the network) is treated as
 * zero used rather than as freeing up extra slots.
 */
export function remainingPhotoBudget(existingCount: number, max: number = MAX_PHOTOS): number {
  const used = Math.max(0, existingCount);
  return Math.max(0, max - used);
}
